class CleverCartAdd extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const that = this;
    that.addEventListener('click', that.clickHandler);
  }
  clickHandler(event) {
    event.preventDefault();
    const that = this;
    const form = that.closest('form[action~="/cart/add"]');
    that.variantId = that.hasAttribute('variant-id') ? Number(that.getAttribute('variant-id')) : null;
    if(!that.variantId && !!form)
      that.variantId = !!form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null;

    that.quantity = that.hasAttribute('quantity') ? Number(that.getAttribute('quantity')) : null;
    if(!that.quantity){
      if(!!form)
        that.quantity = !!form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1;
      else
        that.quantity = 1
    }

    that.selling_plan = that.hasAttribute('selling_plan') ? Number(that.getAttribute('selling_plan')) : null;
    if(!that.selling_plan && !!form)
      that.selling_plan = !!form.querySelector('[name="selling_plan"]') ? form.querySelector('[name="selling_plan"]').value : null;

    that.properties = {}
    if(that.hasAttribute('properties')){
      that.getAttribute('properties').split(',').forEach(p => {
        const key_value = p.split(':');
        if(key_value.length > 1)
          that.properties[key_value[0]] = key_value[1];
      });
    } else if(!!form) {
      Array.from(form.querySelectorAll('[name^="properties"]')).forEach(p => {
        const name = p.getAttribute('name');
        if(!!name){
          const match = name.match(/(?:\[).+?(?=\])/);
          if(!!match){
            const key = match[0];
            that.properties[key] = p.value
          }
        }
      });
    }
    that.disabled = that.hasAttribute('disabled');
    if(!that.disabled){
      const itemsToAdd = {
        items:[{
          id: that.variantId,
          quantity: that.quantity,
          selling_plan: that.selling_plan,
          properties: that.properties
        }]
      }
      Shopify.theme.cart.addToCart(itemsToAdd, true, that.addToCartCallback)
    }
  }
  addToCartCallback(response){
  }
}
customElements.define('clever-cart-add', CleverCartAdd);

class InputChange extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        let target = this.getAttribute('for');
        let to = null, by = null;
        if(this.hasAttribute('to'))
            to = Number(this.getAttribute('to'));
        else if(this.hasAttribute('by'))
            by = Number(this.getAttribute('by'));
        this.addEventListener('click', e => {
            let input = document.getElementById(target);
            if(to != null)
                input.value = Math.max(Math.min(Number(input.max), to), Number(input.min));
            else if(by != null)
                input.value = Math.max(Math.min(Number(input.max), (Number(input.value) + by)), Number(input.min));
            input.dispatchEvent(new Event('change'));
        });
    }
}
customElements.define('input-change', InputChange);

class CleverDrawerToggle extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        const that = this;
        this.for = that.getAttribute('for')
        this.setState(that.getAttribute('state') || 'closed')
        this.setType(that.getAttribute('type') || '')
        this.mode = this.getAttribute('mode').toLowerCase()/* open, close, toggle */

        this.addEventListener('click', (e)=>{
            if(that.mode == 'open'){
                that.open()
            }
            else if(that.mode == 'close'){
                that.close()
            }
            else{
                that.toggle()
            }
        })
    }
    toggle(){
        if(this.state == 'open'){
            this.close()
        }
        else{
            this.open()
        }
    }
    open(){
        this.setState('open',true)

        document.body.style.top = -window.scrollY + 'px';
        if(!this.hasAttribute('data-no-fixed-pos')) {
            document.body.classList.add('is-fixed')
        }

        document.getElementById(this.for).open();
        document.dispatchEvent(new CustomEvent('connected_drawer'));
    }
    close(){
        this.setState('closed',true)

        if(!this.hasAttribute('data-no-fixed-pos')) {
            document.body.classList.remove('is-fixed');
        }

        let lastPosition = Number(document.body.style.top.replace('-','').replace('px',''))
        document.body.style.top = ''
        document.root.style.scrollBehavior = 'auto'
        window.scrollTo({
            top: lastPosition,
            behavior: 'auto'
        })
        document.root.scrollBehavior = '';
        // used to listen for closing the search drawer. Because search drawer has no form anymore and doesn't trigger the form submit event
        document.dispatchEvent(new CustomEvent('closed_drawer_toggle'));
        document.getElementById(this.for).close()
    }
    setState(state, all = false){
        this.state = state;
        this.setAttribute('state',state)
        if(all){
            document.querySelectorAll('[for="'+ this.for +'"]').forEach(element => {
                element.setState(state)
            })    
        }
        
    }
    setType(type){
        this.type = type;
        this.setAttribute('type',type)
    }
}
customElements.define('clever-drawer-toggle', CleverDrawerToggle);

class CleverDrawer extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        const that = this;
        if(this.hasAttribute('backdrop')){
            document.addEventListener('DOMContentLoaded',(e)=>{
                that._createBackdrop()
            })
        }
        this._setPosition(that.getAttribute('position') || 'left')
    }
    open(){
        this.setState('open')
        this.dispatchEvent(new Event('drawer:open'))
    }
    close(){
        this.setState('closed')
        this.dispatchEvent(new Event('drawer:closed'))
    }
    setState(state){
        this.state = state;
        this.setAttribute('state',state)
        if(!!this.backdrop)
            this.backdrop.setState(state)
    }
    _setPosition(position){
        this.position = position;
        this.setAttribute('position',position)
    }
    _createBackdrop(){
        this.backdrop = document.createElement('clever-drawer-toggle')
        this.backdrop.setAttribute('type', 'backdrop')
        this.backdrop.setAttribute('for', this.id)
        this.backdrop.setAttribute('mode','close')
        this.parentNode.insertBefore(this.backdrop, this);
    }
}
customElements.define('clever-drawer', CleverDrawer);
customElements.define('selected-option', class extends HTMLElement {});
customElements.define('clever-options', class extends HTMLElement {});
customElements.define('clever-option', class extends HTMLElement {});

class CleverSelect extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const that = this;
        //Wrap options in custom container
        this._wrapOptions();
        
        //create value holding input
        this._createValueHolder();

        //Get all options
        this.options = this.querySelectorAll('clever-option')

        //Create selected option display
        this._createSelectedOptionDisplay()
        
        //Set event listener for toggling the Select
        this.querySelector('selected-option').addEventListener('click',(e) => {
            that.toggleOpenState();
        })
        this.options.forEach(option => {
            //Set initial selected option
            if(option.hasAttribute('selected')){
                that._setSelectedOption(option, false)
            }
            //Add event listeners to all options
            option.addEventListener('click',(e)=>{
                if(!option.hasAttribute('disabled')){
                    e.preventDefault()
                    that._setSelectedOption(option)
                    that.close();
                }
            })
        })
        
        //Set event listener to close when focus out
        document.body.addEventListener('click',(e) => {
            if(that.hasAttribute('open') && !that.contains(e.target)){
                that.close()
            }
        })
    }
    toggleOpenState(){
        if(this.hasAttribute('open')){
            this.removeAttribute('open')
        }
        else{
            this.setAttribute('open','')
        }
    }
    close(){
        this.removeAttribute('open')
    }

    //this functions should only be used by the element itself
    _setSelectedOption(option, events = true){
        this.value = option.getAttribute('value')
        this.options.forEach(option => {
            option.removeAttribute('selected')
        })
        option.setAttribute('selected', true)
        this.setAttribute('value',this.value)
        this.input.setAttribute('value',this.value)
        this.selectedOption.innerHTML = option.innerHTML;
        if(events){
            this.input.dispatchEvent(new Event('change', {bubbles: true, cancelable: false, composed: true}))
            this.input.dispatchEvent(new Event('input', {bubbles: true, cancelable: false, composed: true}))
        }
    }
    _wrapOptions(){
        let wrappedContent = document.createElement('clever-options');
        let options = this.querySelectorAll('option')
        options.forEach(o => {
            let no = document.createElement('clever-option')
            no.value = o.value;
            no.setAttribute('value', o.value)
            if(o.hasAttribute('selected')){
                no.selected = o.selected;
                no.setAttribute('selected', o.selected)     
            }
            if(o.hasAttribute('disabled')){
                no.disabled = o.disabled;
                no.setAttribute('disabled', o.disabled)     
            }
            

            no.innerHTML = o.innerHTML;
            wrappedContent.appendChild(no)
        })
        this.innerHTML = wrappedContent.outerHTML;
    }
    _createSelectedOptionDisplay(){
        this.selectedOption = document.createElement('selected-option');
        this.selectedOption.innerHTML = String(this.getAttribute('placeholder'))
        this.appendChild(this.selectedOption)
    }
    _createValueHolder(){
        this.input = document.createElement('input')
        this.input.type = 'text'
        this.input.setAttribute('hidden','')
        this.input.setAttribute('name', this.getAttribute('name'))
        this.removeAttribute('name')
        this.appendChild(this.input)
    }
}
customElements.define('clever-select', CleverSelect);

class AccountViewChange extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        const that = this;
        this.sectionUrl = this.getAttribute('section')
        this.for = this.getAttribute('for')
        this.onclick = e => {
            e.preventDefault()
            let viewer = document.querySelector('#'+this.for)
            if(!!viewer){
                viewer.setAttribute('section', this.sectionUrl)
            }
            else{
                let fallback = this.getAttribute('fallback') || '/account';
                location.href = fallback
            }
        }
    }
   
}
customElements.define('account-view-change', AccountViewChange);

class AccountView extends HTMLElement {
    constructor() {
        super();
        this.history = new Array()
    }
    connectedCallback(){
        this.sectionUrl = this.getAttribute('section')
        window.addEventListener('pagehide', this._updateHistory)
        
        if(!!location.hash){
            switch (location.hash) {
                case '#orders':
                    this.setAttribute('section','?section_id=account_orders')
                    break;
                case '#addresses':
                    this.setAttribute('section','?section_id=account_addresses')
                    break;
                case '#change_password':
                    this.setAttribute('section','?section_id=account_change_password')
                    break;
                // case '':
                //     this.setAttribute('section','?section_id=account_overview')
                //     break;
                case '#':
                    this.setAttribute('section','?section_id=account_overview')
                    break;
                default:
                    break;
            }  
        }
        this._updateView()
    }
    _updateView(){
        const that = this;  
        this.setAttribute('loading','')      
        const url = this.sectionUrl.includes('://') ? this.sectionUrl : location.origin + this.sectionUrl;
        fetch(url)
        .then(res => res.text())
        .then(text => {
            let section = new CustomDOMParser().parseFromString(text).querySelector('.shopify-section')
            that.innerHTML = section.innerHTML
            that._reEvaluateScripts()
            that.removeAttribute('loading')
            that._updateHistory()
            that.dispatchEvent(new Event('change'))
        })
    }
    _updateHistory(){
        let currentView = this.getAttribute('section')
        if(currentView.includes('order')){
            location.hash = 'orders'
        }
        else if(currentView.includes('address')){
            location.hash = 'addresses'
        }
        else if(currentView.includes('change_password')){
            location.hash = 'change_password'
        }
        else{
            location.hash = ''
        }
    }
    _reEvaluateScripts(){
        this.querySelectorAll('script').forEach(script => {
            let newScript = document.createElement('script')
            newScript.innerHTML = script.innerHTML;
            Array.from(script.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
            script.replaceWith(newScript)
        })
    }
    attributeChangedCallback(name, oldValue, newValue){
        if(name == 'section'){
            this.sectionUrl = newValue
            this._updateView()
        }
    }
    static get observedAttributes() {
        return ['section']; 
    }
   
}
customElements.define('account-view', AccountView);

class FormSubmit extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback(){
        const that = this;
        this.onclick = e => {
            if(that.hasAttribute('disabled')){
                return;
            }
            
            e.preventDefault()
            that.setAttribute('loading','')      
            that.form = that.closest('form')
            const formId = that.form.getAttribute('id')
            const formErrorsTarget = document.querySelector(`#${formId} form-errors`)
            const formSuccess = document.querySelector(`#${formId} form-success`)

            

            if(!!!formErrorsTarget){
                console.warn(`Form with ID: ${formId} does not contain a form-errors container. No errors will be shown`)
            }
           
            fetch(that.form.getAttribute('action'), {
                method: that.form.getAttribute('method'),
                body: new FormData(that.form)
            })
            .then(res => res.text())
            .then(text => {
                const htmlResponse = new CustomDOMParser().parseFromString(text)
                if(!!htmlResponse.querySelector('link[rel="canonical"]')){
                    const canonical = htmlResponse.querySelector('link[rel="canonical"]').getAttribute('href')
                    if(canonical.includes('/challenge')){
                        console.warn('Disable recaptcha')
                        that.removeAttribute('loading')
                        return;
                    }
                }
                // else{
                //     if(!!formErrorsTarget){
                //         //formErrorsTarget.innerHTML = '<p class="errors spacing-bottom-m">Something went wrong. Try again later.</p>'
                //         that.form.dispatchEvent(new CustomEvent('form:submit:error', { detail: { error: "Invalid response.", response: htmlResponse } }))
                //         console.log(htmlResponse)
                //     }
                //     //that.removeAttribute('loading')
                //     //return
                // }
                if(!!htmlResponse.querySelector('title')){
                    if(htmlResponse.querySelector('title').innerHTML == "Too many attempts"){
                        if(!!formErrorsTarget){
                            formErrorsTarget.innerHTML = '<p class="errors spacing-bottom-m">Too many attempts. Try again later.</p>'
                            that.form.dispatchEvent(new CustomEvent('form:submit:error', { detail: { error: "Too many attempts", response: htmlResponse } }))
                            that.removeAttribute('loading')
                            return;
                        }
                    }
                }
                let formErrors = htmlResponse.querySelector(`#${formId} form-errors`)
                if(!!formErrors){
                    formErrors = formErrors.innerHTML.trim()
                }
                else{
                    formErrors = ''
                }
                if(formErrors != '' && !!formErrorsTarget){
                    formErrorsTarget.innerHTML = formErrors 
                    that.form.dispatchEvent(new CustomEvent('form:submit:error', { detail: { error: formErrors } }))
                }
                else{
                    that.form.dispatchEvent(new CustomEvent('form:submit:success', {}))
                    if(formErrors == '' && !!formErrorsTarget){
                        formErrorsTarget.innerHTML = ''   
                    }
                    if(!!formSuccess){
                        formSuccess.style.display = 'block'
                    }
                }
                that.removeAttribute('loading')
            })
            .catch(err => {
                that.form.dispatchEvent(new CustomEvent('form:submit:error', { detail: { error: err } }))
                that.removeAttribute('loading')
            })
        }
    }
}
customElements.define('form-submit', FormSubmit);
customElements.define('form-errors', class extends HTMLElement{});
customElements.define('form-success', class extends HTMLElement{});

class ParallaxImage extends HTMLElement{ 
    constructor(){
        super()
    }
    connectedCallback(){
        const that = this;
        this._setScrollOffset()
        window.beeclever =  window.beeclever || {}
        window.beeclever.parallaxImages =  window.beeclever.parallaxImages || new Array()
        window.beeclever.parallaxImages.push(this) 
    }
    _setScrollOffset(){
        let wh = window.innerHeight
        let bb = this.getBoundingClientRect()
        this.style.setProperty('--scroll-offset', Math.max(-100, Math.min(100, bb.y / wh)))
    }
}
customElements.define('parallax-image', ParallaxImage);

window.addEventListener('scroll', () => {    
    if(!!window.beeclever && !!window.beeclever.parallaxImages){
        window.beeclever.parallaxImages.forEach(img => {
            img._setScrollOffset()
        })
    }
})

class CleverWishlistAdd extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const that = this;
        const handle = that.getAttribute('handle')
        const type = that.getAttribute('type')

        /* Check if product is allready on wishlist */
        let wishlist = JSON.parse(localStorage.getItem('CleverWishlist-'+window.Shopify.shopID))
        if(!!!wishlist){
            wishlist = { items:[] }
            localStorage.setItem('CleverWishlist-'+window.Shopify.shopID,JSON.stringify(wishlist))
        }
        let item = wishlist.items.find(i => i.handle === handle)
        if(!!item){
            that.setAttribute('added',item.added)
            //that.setAttribute('title','{{section.settings.added}} '+item.added)
        }

        /* Add to wishlist */
        this.onclick = (e) => {
            e.preventDefault();
            wishlist = JSON.parse(localStorage.getItem('CleverWishlist-'+window.Shopify.shopID))
            item = wishlist.items.find(item => item.handle === handle)
            if(!!!item){
                const addedDate = new Date(Date.now()).toLocaleDateString()
                wishlist.items.push({handle: handle, added: addedDate, type: type })
                
                document.querySelectorAll('clever-wishlist-add[handle="'+handle+'"]').forEach(cwa => {
                    cwa.setAttribute('added', addedDate)
                })
            }
            else{
                wishlist.items = wishlist.items.filter(i => i.handle !== handle)
                that.removeAttribute('added')
                that.removeAttribute('title')
                document.querySelectorAll('clever-wishlist-add[handle="'+handle+'"]').forEach(cwa => {
                    cwa.removeAttribute('added')
                    cwa.removeAttribute('title')
                })
            }
            localStorage.setItem('CleverWishlist-'+window.Shopify.shopID,JSON.stringify(wishlist))
            if(!!!item){
                that.dispatchAddNotification()
            }
            else{
                that.dispatchRemoveNotification()
            }
        }
    }
    dispatchAddNotification(){
        window.dispatchEvent(new Event('wishlist:added'))
    }
    dispatchRemoveNotification(){
        window.dispatchEvent(new Event('wishlist:removed'))
    }
}
customElements.define('clever-wishlist-add', CleverWishlistAdd);

class TabButton extends HTMLElement {
    static OpenStates = new Map()

    constructor() {
        super();
    }

    connectedCallback() {
        this.for = this.getAttribute('for');
        this.group = this.getAttribute('group') || null;
        this.isOpen = this.hasAttribute('is-open')
        this.isPersistent = this.hasAttribute('persistent')

        if(!this.isOpen){
            this.removeAttribute('is-open')
            this.setAttribute('is-closed','')
        }

        this.addEventListener('click', () => {
            if(this.isOpen){
                this.close()
            }
            else{
                this.open()
            }
        })

        if(this.isPersistent && TabButton.OpenStates.has(this.for) && TabButton.OpenStates.get(this.for)){
            this.open()
        }
    }
    open(){
        if(!!this.group){
            document.querySelectorAll('tab-button[group="' + this.group + '"]').forEach(t => t.close())
        }
        this.removeAttribute('is-closed')
        this.setAttribute('is-open','')
        this.isOpen = true
        document.querySelector('tab-content#'+ this.for).removeAttribute('is-closed')
        document.querySelector('tab-content#'+ this.for).setAttribute('is-open','')
        if(this.isPersistent){
            TabButton.OpenStates.set(this.for, this.isOpen)
        }
    }
    close(){
        this.removeAttribute('is-open')
        this.setAttribute('is-closed','')
        this.isOpen = false
        document.querySelector('tab-content#'+ this.for).removeAttribute('is-open')
        document.querySelector('tab-content#'+ this.for).setAttribute('is-closed','')
        if(this.isPersistent){
            TabButton.OpenStates.set(this.for, this.isOpen)
        }
    }
}
customElements.define('tab-button', TabButton);
customElements.define('tab-content', class extends HTMLElement{});

class ExternalVideo extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const that = this;
    const external_placeholder = that.querySelector('ev-source');
    that.dataset.state = 'unset';
    if(!!external_placeholder) {
      if (typeof YT == "undefined"){
        console.log('YT undefined')
        window.YT = {};
        window.onYouTubeIframeAPIReady = function(){
          document.dispatchEvent(new Event('YT:ready'))
        }
        let iframe_api = document.createElement('script');
        iframe_api.id = 'iframe_api';
        iframe_api.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(iframe_api);
        document.addEventListener('YT:ready', () => {
          that._loadVideo();
        });
      }else if(Object.keys(YT).length === 0){
        console.log('YT loading')
        document.addEventListener('YT:ready', () => {
          that._loadVideo();
        });
      }else{
        console.log('YT ready')
        that._loadVideo();
      }
    } else {
      console.error('external video does not contain ev-source')
    }
  }
  _loadVideo() {
    if(this.hasAttribute('loading') && this.getAttribute('loading') == 'lazy'){
      this._lazyLoadVideo()
    } else {
      this._eagerLoadVideo()
    }
  }
  _lazyLoadVideo() {
    this.intersectionObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(async (entry) => {
          if (entry.isIntersecting){
            this._eagerLoadVideo()
            observer.unobserve(entry.target)
            observer.disconnect()
          }
        })
      }, 
      {
        root: null,
        rootMargin: '500px',
        threshold: 0
      }
    )
    this.intersectionObserver.observe(this)
  }
  _eagerLoadVideo() {
    const external_placeholder = this.querySelector('ev-source');
    this.player = new YT.Player(external_placeholder, {
      width: '1600',
      height: '900',
      videoId: this.dataset.videoId,
      playerVars: {
          showinfo: 0,
          enablejsapi: 1,
          autoplay: 0,
          origin: '{{request.origin}}',
          iv_load_policy: 3,
          modestbranding: 1,
          controls: 1,
          playsinline: 1,
          showinfo: 0,
          playlist: this.dataset.videoId,
          loop: 1,
          rel: 0,
          mute: this.hasAttribute('mute') ? 1 : 0
      },
      events: {
        'onReady': this._onPlayerReady.bind(this),
        'onStateChange': this._onPlayerStateChange.bind(this)
      }
    });
  }
  _onPlayerReady() { 
    console.log('exteral video ready');
    if(this.hasAttribute('autoplay')){
      if(this.player.getPlayerState() == 1)
        this.player.pauseVideo();
      else{
        this.player.playVideo();
      }
    }
  }
  _onPlayerStateChange(event){
    let state = 'unset'
    switch (event.data) {
      case -1:
        state = 'unstarted'
        break;
      case 0:
        state = 'end'
        break;
      case 1:
        state = 'play'
        break;
      case 2:
        state = 'pause'
        break;
      case 3:
        state = 'loading'
        break;
      case 5:
        state = 'cued'
        break;
      default:
        state = 'unset'
        break;
    }
    this.dataset.state = state;
  }
}
customElements.define('external-video', ExternalVideo);
class LoadMore extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.nextPage = this.getAttribute('next-page')
        this.for = this.getAttribute('for')
        this.id = this.getAttribute('id')
        this.gamification = this.getAttribute('gamification')
        this.sectionId = this.getAttribute('section-id')

        this.addEventListener('click', async (e) => {
            this.setAttribute('loading', '')
            let nextPageSection = await fetch(this.nextPage + '&section_id=' + this.sectionId)
            .then(res => res.text())
            .then(text => new CustomDOMParser().parseFromString(text))

            let nextPageContent = nextPageSection.querySelector('#' + this.for)
            document.querySelector('#' + this.for).insertAdjacentHTML('beforeend', nextPageContent.innerHTML)

            if (this.gamification != null) {
                let nextPageCountGamification = nextPageSection.querySelector('#' + this.gamification)
                if(!!nextPageCountGamification){
                    document.querySelector('#' + this.gamification).innerHTML = nextPageCountGamification.innerHTML
                }  else {
                    document.querySelector('#' + this.gamification).remove()
                }
            }
            // correct order style values 
            document.querySelectorAll('#' + this.for + ' .product_item').forEach((item, index) => {
                item.style.order = index
            })
            let counter_value = document.querySelector('#count_gamification span.current_value')
            if (!!counter_value) counter_value.innerHTML = document.querySelectorAll('#product_grid .product_item').length

          
            let nextPageLeadMore = nextPageSection.querySelector('#' + this.id)
            if(!!nextPageLeadMore){
                this.replaceWith(nextPageLeadMore)
                this.removeAttribute('loading')
            }
            else{
                this.remove()
            }
        })
    }
}
customElements.define('load-more', LoadMore);

class FilterForm extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.sectionId = this.getAttribute('section-id')
        setTimeout(() => {
            this.setEventListeners()
        }, 100)
        

    }
    reinit(){
        console.log('reinit')
    }

    setEventListeners(){
        let filterInputs = this.querySelectorAll('input[name^="filter."]')
        let sortBy = document.querySelector('[name="sort_by"]')
        // ToDo: abstract
        let priceReset = document.querySelector('label[for="Filter-filter-v-price"]')
        let resets = this.querySelectorAll('button[type="reset"]')
        if(!!resets){
            resets.forEach(element => {
                element.addEventListener('click', () => {
                    this.applyFilterAndSort(null, null, this.sectionId)
                })
            })
        }
        // ToDo: abstract
        if(!!priceReset){
            priceReset.addEventListener('click', () => {
                document.querySelector('#price-range').reset()
            }) 
        }
        this.onchangeCallback = () => {
            this.applyFilterAndSort(filterInputs, sortBy)
        }
        filterInputs.forEach(input => {
            input.addEventListener('change', this.onchangeCallback)
        })
        sortBy.addEventListener('change', this.onchangeCallback)
    }

    async applyFilterAndSort(filters, sort){
        const section = document.querySelector('#shopify-section-' + this.sectionId)

        const newUrl = this.buildFilterQuery(filters, sort)

        const updatedSection = await fetch(newUrl.href + '&section_id=' + this.sectionId)
        .then(res => res.text())
        .then(text => new CustomDOMParser().parseFromString(text).querySelector('#shopify-section-' + this.sectionId))


        const replaceSelectors = ['[filter-bar]', '[filter-form]', '[load-more]','[product-grid]','#count_gamification']
        replaceSelectors.forEach(s => {
             if (!!updatedSection.querySelector(s)) {
                section.querySelector(s).replaceWith(updatedSection.querySelector(s))
            }
        })
        let counter_value = document.querySelector('#count_gamification span.current_value')
        if (!!counter_value) counter_value.innerHTML = document.querySelectorAll('#product_grid .product_item').length

        history.replaceState({}, '', newUrl.href);
        
        this.setEventListeners()
    }
    //Todo: styling

    buildFilterQuery(filters, sort){
        let url = new URL(location)
        let filterNames = new Set()

        //remove all filter params
        let deleteKeys = []
        url.searchParams.forEach((value, key) => {
            if(key.startsWith('filter.')){
                deleteKeys.push(key)
            }
        })
        for(const key of deleteKeys){
            url.searchParams.delete(key)
        }
        if(sort === null){
            url.searchParams.delete('sort_by')
        }

        if(filters === null){
            return url;
        }

        filters.forEach(input => {
            //skip unchecked values
            if((input.type == 'checkbox' || input.type == 'radio') && !input.checked ){
                return;
            }
            if(filterNames.has(input.name)){
                url.searchParams.set(input.name, url.searchParams.get(input.name) + ',' + input.value)
            }
            else{
                filterNames.add(input.name)
                url.searchParams.set(input.name, input.value)
            }
            
        })
        url.searchParams.set(sort.name, sort.value)

        url.searchParams.set('page', 1)

        url.search = decodeURIComponent(url.search)

        return url
    }
}
customElements.define('filter-form', FilterForm);

class PictureWrapper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const that = this;
    that.image = that.querySelector('img');
    if(document.readyState !== 'complete')
      that.classList.add('initial');
    if(that.image){
      if (that.image.complete){
        that.classList.add('complete');
      }else{
        that.image.addEventListener('load', () => {
          if(that.image.complete)
            that.classList.add('complete');
        });
      }
    }else{
      that.classList.add('complete');
    }
  }
}
customElements.define('picture-wrapper', PictureWrapper);
